var map = {
	"./decorate_unit_activity.png": "dbad",
	"./decorate_unit_banner.png": "0565",
	"./decorate_unit_cell_icon.png": "eb09",
	"./decorate_unit_channel_banner.png": "3b97",
	"./decorate_unit_channel_image_list.png": "03b2",
	"./decorate_unit_img_advert.png": "e85d",
	"./decorate_unit_link_area.png": "d4d7",
	"./decorate_unit_product.png": "977d",
	"./decorate_unit_roll_icon.png": "5105",
	"./decorate_unit_separator.png": "f6a4",
	"./decorate_unit_update.png": "af35"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b120";